import { Component, ChangeDetectionStrategy } from '@angular/core';
import { PagedObjectManagerComponent } from '../../../core/component/paged-object-manager/paged-object-manager';
import { standardCommand } from '../../../core/model/command';
import { FilterDefinitionItem } from '../../../core/model/filter-definition-item';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { BrfTransferListItem } from '../../model/Transfer/brftransfer-list-item';
import { ColumnDefinitionService } from '../../service/data/column-definition.service';
import { CompanyService } from '../../service/data/company.service';
import { CooperativeHousingTransferService } from '../../service/data/cooperative-housing-transfer.service';
import { transferCommand } from '../../command/transfer.command';
import { CooperativeHousingTransferCommandHandlerResolver } from '../../service/command/cooperative-housing-transfer-command-handler-resolver.service';
import { MultiselectObjectManagerComponentBase } from '../../../core/component/multiselect-object-manager/multiselect-object-manager.component';
import { UpdateTransferCommandHandler } from '../../../accounting/service/command/update-transfer-command-handler.service';
import { DataService } from '../../../core/service/base/data.service';
import { CommandFactoryService } from '../../../core/service/factory/command-factory.service';
import { CooperativeHousingTransferCommandFactory } from '../../service/command/factory/cooperative-housing-transfer-command-factory.service';
import { leaseAgreementCommand } from '../../command/lease-agreement.command';

@Component({
    selector: 'app-brf-transfer-manager',
    templateUrl: './cooperative-housing-transfer-manager.component.html',
    styleUrls: ['./cooperative-housing-transfer-manager.component.scss'],
    providers: [
        NavigationService,
        UpdateTransferCommandHandler,
        { provide: DataService, useExisting: CooperativeHousingTransferService },
        { provide: CommandHandlerResolver, useExisting: CooperativeHousingTransferCommandHandlerResolver },
        { provide: CommandFactoryService, useClass: CooperativeHousingTransferCommandFactory },
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CooperativeHousingTransferManagerComponent extends MultiselectObjectManagerComponentBase<BrfTransferListItem> {
  constructor(
    columnDefinitionService: ColumnDefinitionService,
    private readonly _dataService: CooperativeHousingTransferService,
    private readonly _companyService: CompanyService,
    dispatcher: CommandDispatcher,
    messageService: MessageService,
    navigationService: NavigationService,
    handlerResolver: CommandHandlerResolver
  ) {
    super(_dataService, dispatcher, handlerResolver, messageService, navigationService);

    this.allowNew = true;
    this.columnDefinition = columnDefinitionService.create('CooperativeHousingTransfer');
    this.title = 'COOPERATIVE_HOUSING.TRANSFER_LIST_HEADER';
    this.preferencesKey = 'rent.cooperative-housing-transfer.list';
  }

  ngOnInit() {
    this.AddSubscription(
      this._dataService.getFilterDefinition().subscribe(definition => {
        this.defaultFilters = definition.defaultFields;
        this.filterDefinition = [
          new FilterDefinitionItem(
            'COMMON.COMPANY',
            'companyId',
            definition.companyId,
            this._companyService,
            definition.selectedFields.includes('companyId')
          ),
          new FilterDefinitionItem(
            'COMMON.INCOME_YEAR',
            'incomeYear',
            definition.incomeYear,
            null,
            definition.selectedFields.includes('incomeYear')
          ),
          new FilterDefinitionItem(
            'RENTAL_OBJECT_FORM.RENTAL_OBJECT_NUMBER_LABEL',
            'rentalId',
            definition.rentalId,
            null,
            definition.selectedFields.includes('rentalId')
          ),
          new FilterDefinitionItem(
            'COOPERATIVE_HOUSING.TRANSFER_SELLER',
            'sellerContactName',
            definition.sellerContactName,
            null,
            definition.selectedFields.includes('sellerContactName')
          ),
        ];
      })
    );

    this.addContextMenuItemDefinition('EDIT_BTN', standardCommand.edit);
    this.addContextMenuItemDefinition('DELETE_BTN', standardCommand.delete);
    this.addMultiselectMenuItem('COOPERATIVE_HOUSING.UPDATE_TRANSFER', transferCommand.updateTransfer);
  }
}
